import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getQuotationbyVersionId } from '../../services/SearchVehicle/getVehicleData';
import { extractVehData } from '../../Store/helpers/pricing';

export const useDevinDecoding = (versions, versionType, currentVersion) => {
  const [quotaionVersions, setQuotationVersion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpenEquipments, setIsOpenEquipments] = useState(false);
  const { recordId } = useParams();
  const record = useSelector((state) => state.reduxRecords.data[recordId]);
  const recordMileage = useSelector((state) => state.reduxRecords.data[recordId]?.vehicle?.mileage);

  const getQuotation = async () => {
    setLoading(true);
    const mileAge = recordMileage;
    const { yearMec } = extractVehData(record);
    const newData = await Promise.all(
      versions.slice(-10).map(async (v) => {
        try {
          const quotation = await getQuotationbyVersionId(v.id, mileAge, yearMec);
          return { ...v, quotation: quotation || null };
        } catch (error) {
          return v;
        }
      }),
    );
    setQuotationVersion(newData);
    setLoading(false);
  };

  useEffect(() => {
    if (versionType === 'vin') getQuotation();
  }, [versionType]);

  useEffect(() => {
    if (versionType === 'vin' && quotaionVersions) {
      setQuotationVersion(
        quotaionVersions.map((v) =>
          v.id.toString() === currentVersion.toString() ? { ...v, selected: true } : { ...v, selected: false },
        ),
      );
    }
  }, [currentVersion, versionType]);

  return { quotaionVersions, loading, isOpenEquipments, setIsOpenEquipments };
};
